function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBoostedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m834.77 384.95 230.89 33.277c65.473 9.4336 91.703 89.855 44.398 136.08l-166.86 163.02c-18.793 18.359-27.336 44.785-22.871 70.668l39.707 229.87c11.258 65.184-57.109 114.98-115.7 84.277l-206.61-108.3c-23.27-12.191-51.047-12.168-74.281 0.085937l-206.35 108.8c-58.512 30.852-127.01-18.793-115.91-84l39.156-229.97c4.4023-25.895-4.1992-52.309-23.039-70.621l-167.22-162.62c-47.426-46.117-21.383-126.6 44.074-136.19l230.81-33.816c25.992-3.8047 48.445-20.16 60.035-43.727l103-209.32c29.207-59.352 113.8-59.461 143.14-0.16797l103.49 209.06c11.652 23.531 34.141 39.84 60.145 43.586z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 803.34363,419.5318 197.78947,28.15593 c 56.0868,7.98183 78.5564,76.02701 38.0331,115.13834 L 896.22731,700.75854 c -16.09883,15.5337 -23.41709,37.89294 -19.5922,59.79275 l 34.01458,194.49476 c 9.64404,55.15275 -48.92181,97.28545 -99.11316,71.30755 L 634.5463,934.72003 c -19.93399,-10.31488 -43.72886,-10.29542 -63.63202,0.0729 l -176.76749,92.05647 c -50.12367,26.1041 -108.80174,-15.9008 -99.29304,-71.0731 L 328.3963,761.19688 c 3.77119,-21.90995 -3.5972,-44.25905 -19.73611,-59.75297 L 165.41298,563.84986 C 124.78601,524.82991 147.09547,456.73262 203.16851,448.61844 L 400.8894,420.00646 c 22.26576,-3.21918 41.49989,-17.05753 51.42833,-36.99774 l 88.23384,-177.10728 c 25.01985,-50.21818 97.48553,-50.3104 122.61933,-0.14212 l 88.6536,176.88729 c 9.98155,19.90976 29.24651,33.70894 51.52255,36.87845 z",
    style: {
      fill: "#ffcc00",
      strokeWidth: 0.851357
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBoostedIcon);
export default __webpack_public_path__ + "static/media/star_boosted_icon.91520c2b6f2ed4c8e243c9be159fa005.svg";
export { ForwardRef as ReactComponent };